import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getIsImporting = (state) => get(state, 'import.form.isImporting', false);
export const getFile = (state) => get(state, 'import.form.file', null);
export const getModule = (state) => get(state, 'import.form.module', null);
export const getHeaders = (state) => get(state, 'import.form.headers', null);
export const getHeadersSelect = (state) => get(state, 'import.form.headersSelect', null);
export const getHeadersOpciones = (state) => get(state, 'import.form.headersOpciones', null);

export const getPagination = (state) => get(state, 'import.list.pagination', {});

export const getFilters = (state) => get(state, 'import.list.filters', {});

export const getNeedFetch = (state) => get(state, 'import.list.needFetch', false);

export const getIsLoading = (state) => get(state, 'import.list.isLoading', false);

export const getRecords = (state) => get(state, 'import.list.entities.records', {});
export const getRecordsIds = (state) => get(state, 'import.list.result.records', []);

export const getVisibleRecords = createSelector([getRecordsIds, getRecords], (ids, records) =>
  ids.map((id) => records[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/selectors/import_selectors.js